// Session-only (in-memory, resets on reload) handoff from SampleOverlay's
// Done button to IngestQueuePage: which fabricated samples have been opened
// this session (so their rows stay visible on every later visit), and which
// one was *just* opened (a one-shot pointer, so only that one auto-opens
// into the breakdown — not every previously-opened sample on every visit).
// No persistence, no React, no import of ingestApi — this never touches
// anything real.

const opened = new Set<string>();
let pending: string | null = null;

export function markSampleOpened(key: string): void {
  opened.add(key);
  pending = key;
}

export function getOpenedSamples(): string[] {
  return Array.from(opened);
}

export function takePendingSample(): string | null {
  const key = pending;
  pending = null;
  return key;
}
